import { render } from "./PopupMetaData.vue?vue&type=template&id=2c482ff1&scoped=true&ts=true"
import script from "./PopupMetaData.vue?vue&type=script&lang=ts"
export * from "./PopupMetaData.vue?vue&type=script&lang=ts"

import "./PopupMetaData.vue?vue&type=style&index=0&id=2c482ff1&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c482ff1"]])

export default __exports__